import React from 'react';

export default function Accordion({ className, visible, children, horizontal=false, duration=250, timing="ease-out" }) {
  // 0 = visible/expanding, 1 = collapsing, 2 = collapsed, 3 = ready to expand
  const [state, setState] = React.useState(visible ? 0 : 2);
  const [size, setSize] = React.useState();

  const outerRef = React.useRef();
  const timeoutRef = React.useRef();
  const innerRef = React.useRef();
  React.useLayoutEffect(() => {
    if (state === 0 && !visible) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      const size = horizontal ? innerRef.current.offsetWidth : innerRef.current.offsetHeight;
      outerRef.current.style[horizontal ? "maxWidth" : "maxHeight"] = size + "px";
      setSize(size);
      setState(1);
      timeoutRef.current = setTimeout(() => setState(2), duration);
    } else if (state !== 1 && visible) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setState(0);
      timeoutRef.current = null;
    }
  }, [visible, state, duration, horizontal]);

  const resetRef = React.useRef();
  React.useLayoutEffect(() => {
    if (resetRef.current) {
      clearTimeout(resetRef.current);
      resetRef.current = null;
    }
    if (state === 0) {
      setSize(horizontal ? innerRef.current.offsetWidth : innerRef.current.offsetHeight);
      resetRef.current = setTimeout(() => setSize(null), duration);
    } else {
      setSize(0);
    }
  }, [horizontal, state, visible, duration]);

  React.useEffect(() => (() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (resetRef.current) clearTimeout(resetRef.current);
  }), []);

  if (state === 2) return null;

  const style = {transition: `${horizontal ? "max-width" : "max-height"} ${duration}ms ${timing}`};
  if (size != null) {
    style[horizontal ? "maxWidth" : "maxHeight"] = size + "px";
    style.overflow = "hidden";
  }

  return (
    <div style={style} ref={outerRef}>
      <div ref={innerRef} className={className}>
        {children}
      </div>
    </div>
  );
}
